module.exports = __webpack_public_path__ + "static/media/education.f17b17ea.svg";